/* Shared Shopify cart for the NuMuti preview layouts. Prices always come from Shopify. */
(() => {
  'use strict';
  const drawer = document.getElementById('nu-cart-drawer');
  const configElement = document.getElementById('nu-cart-config');
  if (!drawer || !configElement || window.NuCart) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const root = '/' + String(config.root || '/').replace(/^\/+|\/+$/g, '');
  const base = root === '/' ? '/' : root + '/';
  const content = drawer.querySelector('[data-nu-cart-content]');
  const status = drawer.querySelector('.nu-cart-status');
  const errorBox = drawer.querySelector('.nu-cart-error');
  const bottom = drawer.querySelector('.nu-cart-bottom');
  const checkout = drawer.querySelector('.nu-cart-checkout');
  const checkoutForm = drawer.querySelector('.nu-cart-checkout-form');
  let cart = null;
  let opener = null;
  let mutation = null;
  let readVersion = 0;
  let busy = false;
  let closedPointer = false;

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function price(cents) {
    const currency = (cart && cart.currency) || config.currency || 'USD';
    try { return new Intl.NumberFormat(config.locale || 'en', { style:'currency', currency }).format(Number(cents) / 100); }
    catch (_) { return currency + ' ' + (Number(cents) / 100).toFixed(2); }
  }
  function previewUrl(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) return base;
    if (config.isDraft && config.themeId) url.searchParams.set('preview_theme_id', String(config.themeId));
    return url.pathname + url.search + url.hash;
  }
  function productUrl(item) {
    const value = [item && item.handle, item && item.product_title, item && item.title].filter(Boolean).join(' ').toLowerCase();
    if (!item || /baobab|marula/.test(value)) {
      const flavor = value.includes('marula') && !value.includes('baobab') ? 'marula' : 'baobab';
      const path = config.shopUrls?.[flavor] || base + 'products/baobab?view=nu-foundation&flavor=' + flavor;
      const url = new URL(previewUrl(path), location.origin);
      if (Number.isSafeInteger(item?.variant_id)) url.searchParams.set('variant', String(item.variant_id));
      return url.pathname + url.search + url.hash;
    }
    return previewUrl(item.url || base + 'products/' + encodeURIComponent(item.handle || 'baobab'));
  }
  function announce(message) { status.textContent = message; }
  function clearError() { errorBox.hidden = true; errorBox.textContent = ''; }
  function report(error) {
    errorBox.textContent = error && error.message ? error.message : 'We couldn’t update your cart. Please try again.';
    errorBox.hidden = false;
  }
  function setBusy(value) {
    busy = value;
    content.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('.nu-cart-quantity, .nu-cart-remove').forEach(control => { control.disabled = value || !cart; });
    checkout.disabled = value || !cart || !cart.item_count;
  }
  function validCart(value) { return value && Array.isArray(value.items) && Number.isFinite(value.item_count) && Number.isFinite(value.total_price); }
  async function request(path, data) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(base + path, {
        method:data ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', signal:controller.signal,
        headers:{ Accept:'application/json', ...(data ? {'Content-Type':'application/json'} : {}) },
        ...(data ? {body:JSON.stringify(data)} : {})
      });
      let result;
      try { result = await response.json(); } catch (_) {
        const error = new Error(data ? 'We couldn’t confirm the update. Reopen your cart to check it before trying again.' : 'Your cart could not be loaded. Please try again.');
        error.cartUpdateUnconfirmed = Boolean(data);
        throw error;
      }
      if (!response.ok) {
        const detail = typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : '';
        throw new Error(detail || 'We couldn’t update your cart. Please try again.');
      }
      return result;
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError) {
        const failure = new Error(data ? 'We couldn’t confirm the update. Reopen your cart to check it before trying again.' : 'Your cart could not be loaded. Please check your connection and try again.');
        failure.cartUpdateUnconfirmed = Boolean(data);
        throw failure;
      }
      throw error;
    } finally { clearTimeout(timeout); }
  }
  function render(value, focusTarget) {
    if (!validCart(value)) throw new Error('Your cart could not be loaded. Please try again.');
    cart = value;
    document.querySelectorAll('[data-nu-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
    content.replaceChildren();
    bottom.hidden = !cart.item_count;
    if (!cart.item_count) {
      const empty = el('div', 'nu-cart-empty');
      const shop = el('a', 'nu-cart-shop', 'Explore the flavors');
      shop.href = productUrl(null);
      shop.setAttribute('data-nu-preview-link', '');
      empty.append(el('p', '', 'Your cart is empty.'), shop);
      content.append(empty);
    } else {
      const list = el('ul', 'nu-cart-items');
      cart.items.forEach((item, index) => {
        const row = el('li', 'nu-cart-item');
        row.dataset.lineKey = item.key;
        const title = String(item.product_title || item.title || 'NuMuti');
        const imageSource = item.featured_image && item.featured_image.url || item.image;
        let imageUrl;
        try { imageUrl = imageSource && new URL(imageSource, location.origin); } catch (_) {}
        if (imageUrl && /^https?:$/.test(imageUrl.protocol)) {
          const image = el('img', 'nu-cart-item-image');
          image.src = imageUrl.href;
          image.alt = item.featured_image && item.featured_image.alt || title;
          image.width = 72;
          image.height = 92;
          image.loading = 'lazy';
          row.append(image);
        } else row.append(el('div', 'nu-cart-item-placeholder'));
        const details = el('div', 'nu-cart-item-detail');
        const link = el('a', 'nu-cart-item-title', title);
        link.href = productUrl(item);
        link.setAttribute('data-nu-preview-link', '');
        details.append(link);
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(el('p', 'nu-cart-item-variant', item.variant_title));
        const amount = el('p', 'nu-cart-item-price');
        if (item.original_line_price > item.final_line_price) amount.append(el('s', 'nu-cart-item-original', price(item.original_line_price)));
        amount.append(el('span', '', price(item.final_line_price ?? item.line_price)));
        const actions = el('div', 'nu-cart-item-actions');
        const quantityWrap = el('div', 'nu-cart-quantity-wrap');
        const label = el('label', '', 'Qty');
        const quantity = el('input', 'nu-cart-quantity');
        quantity.type = 'number'; quantity.min = '0'; quantity.step = '1'; quantity.inputMode = 'numeric';
        quantity.id = 'nu-cart-quantity-' + index;
        quantity.value = String(item.quantity);
        quantity.setAttribute('aria-label', 'Quantity for ' + title);
        quantity.dataset.lineKey = item.key;
        quantity.dataset.savedQuantity = String(item.quantity);
        label.htmlFor = quantity.id;
        quantityWrap.append(label, quantity);
        const remove = el('button', 'nu-cart-remove', 'Remove');
        remove.type = 'button'; remove.dataset.lineKey = item.key;
        remove.setAttribute('aria-label', 'Remove ' + title);
        actions.append(quantityWrap, remove);
        details.append(amount, actions);
        row.append(details);
        list.append(row);
      });
      content.append(list);
      drawer.querySelector('[data-nu-cart-total]').textContent = price(cart.total_price);
    }
    setBusy(busy);
    document.dispatchEvent(new CustomEvent('nu:cart-updated', {detail:{cart}}));
    if (focusTarget && drawer.open) {
      const row = [...content.querySelectorAll('[data-line-key]')].find(node => node.classList.contains('nu-cart-item') && node.dataset.lineKey === focusTarget.key);
      (row && row.querySelector(focusTarget.selector) || content.querySelector('.nu-cart-quantity, .nu-cart-shop') || drawer.querySelector('[data-nu-cart-close]')).focus({preventScroll:true});
    }
    return cart;
  }
  async function loadCart() {
    const version = ++readVersion;
    const value = await request('cart.js');
    if (version === readVersion) return render(value);
    return cart;
  }
  async function refresh() { return mutation || loadCart(); }
  function show(openerElement) {
    if (!drawer.open) {
      opener = openerElement instanceof HTMLElement ? openerElement : document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('nu-cart-lock');
      document.querySelectorAll('.nu-cart-open').forEach(button => button.setAttribute('aria-expanded', 'true'));
      drawer.querySelector('[data-nu-cart-close]').focus({preventScroll:true});
    }
  }
  async function open(openerElement) {
    show(openerElement);
    clearError();
    try { return await refresh(); } catch (error) { report(error); return null; }
  }
  function close() { if (drawer.open) drawer.close(); }
  function afterClose() {
    document.documentElement.classList.remove('nu-cart-lock');
    document.querySelectorAll('.nu-cart-open').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  }
  function add(items, openerElement) {
    if (mutation) return mutation;
    show(openerElement);
    clearError();
    if (!Array.isArray(items) || !items.length || items.some(item => !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || !Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 1)) {
      const error = new Error('Please choose an available product before adding it to your cart.');
      report(error);
      return Promise.reject(error);
    }
    const payload = items.map(item => ({...item, id:Number(item.id), quantity:Number(item.quantity)}));
    ++readVersion;
    setBusy(true);
    announce('Adding to your cart…');
    mutation = (async () => {
      let added = false;
      try {
        await request('cart/add.js', {items:payload});
        added = true;
        await loadCart();
        announce('Added to your cart.');
        return cart;
      } catch (error) {
        announce('');
        if (added || error.cartUpdateUnconfirmed) cart = null;
        if (added) error = new Error('Your item was added, but your cart could not reload. Reopen your cart to check it.');
        report(error);
        throw error;
      } finally { mutation = null; setBusy(false); }
    })();
    return mutation;
  }
  function change(key, quantity, selector) {
    if (mutation) return mutation;
    clearError();
    ++readVersion;
    setBusy(true);
    announce(quantity === 0 ? 'Removing item…' : 'Updating your cart…');
    mutation = (async () => {
      let changed = false;
      try {
        const value = await request('cart/change.js', {id:key, quantity});
        changed = true;
        render(value);
        announce(quantity === 0 ? 'Item removed.' : 'Cart updated.');
        return cart;
      } catch (error) {
        if (changed || error.cartUpdateUnconfirmed) cart = null;
        if (cart) render(cart);
        announce('');
        report(error);
        throw error;
      } finally {
        mutation = null;
        setBusy(false);
        if (drawer.open && cart) {
          const row = [...content.querySelectorAll('.nu-cart-item')].find(node => node.dataset.lineKey === key);
          (row && row.querySelector(selector) || content.querySelector('.nu-cart-quantity, .nu-cart-shop') || drawer.querySelector('[data-nu-cart-close]')).focus({preventScroll:true});
        }
      }
    })();
    return mutation;
  }

  document.addEventListener('click', event => {
    const button = event.target instanceof Element && event.target.closest('.nu-cart-open');
    if (!button) return;
    event.preventDefault();
    open(button);
  });
  drawer.addEventListener('click', event => {
    const target = event.target instanceof Element && event.target;
    if (!target) return;
    if (target.closest('[data-nu-cart-close]')) close();
    const remove = target.closest('.nu-cart-remove');
    if (remove && !busy) change(remove.dataset.lineKey, 0, '.nu-cart-remove').catch(() => {});
  });
  content.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('nu-cart-quantity') || busy) return;
    const quantity = Number(input.value);
    if (!input.value.trim() || !Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = input.dataset.savedQuantity;
      report(new Error('Please enter a whole number of zero or more.'));
      input.focus();
      return;
    }
    if (quantity !== Number(input.dataset.savedQuantity)) change(input.dataset.lineKey, quantity, '.nu-cart-quantity').catch(() => {});
  });
  drawer.addEventListener('pointerdown', event => { closedPointer = event.target === drawer && event.clientX < drawer.getBoundingClientRect().left; });
  drawer.addEventListener('pointerup', event => { if (closedPointer && event.target === drawer && event.clientX < drawer.getBoundingClientRect().left) close(); closedPointer = false; });
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('close', afterClose);
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')].filter(node => node.getClientRects().length && !node.closest('[hidden]'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  checkoutForm.addEventListener('submit', event => {
    if (busy || !cart || !cart.item_count) { event.preventDefault(); return; }
    // Shopify receives its ordinary cart form and checkout button. No payment settings are changed.
  });
  document.querySelectorAll('.nu-cart-open').forEach(button => {
    button.setAttribute('aria-controls', drawer.id);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
  });
  window.NuCart = Object.freeze({add, open, refresh});
  loadCart().catch(() => { /* An offline background read must not interrupt the page. Opening retries it. */ });
})();
